module.exports = __webpack_public_path__ + "static/media/tinder_profiles.e7a121b0.jpg";